var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"loading":_vm.loading,"columns":_vm.columns,"data":_vm.data}}),_c('Page',{attrs:{"total":_vm.total,"current":_vm.current,"page-size":_vm.size,"show-elevator":"","show-total":"","class-name":"page-class"},on:{"on-change":_vm.changePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }